import { useEffect, useState } from "react";
import api from "@/lib/api";

export const vehicleLabel = (code, plate, brand) =>
  [code, plate, brand].map((x) => String(x || "").trim()).filter(Boolean).join(" — ");

export const normPlate = (p) => {
  const s = String(p || "").toUpperCase().replace(/\s+/g, "");
  return s.startsWith("16") ? s.slice(2) : s;
};

// Plaka (normalize) → araç kaydı haritası; markayı göstermek için kullanılır.
export function useVehicleMap() {
  const [map, setMap] = useState({});
  useEffect(() => {
    api.get("/vehicles").then((r) => {
      const m = {};
      (r.data || []).forEach((v) => { m[normPlate(v.plate)] = v; });
      setMap(m);
    }).catch(() => {});
  }, []);
  return map;
}

export const brandOf = (map, plate) => (map[normPlate(plate)]?.brand || "").trim();
